import React from 'react';
import { useDispatch } from 'react-redux';
import Dropdown from '../../Dropdown';
import types from '../../../../redux/types';

const Title = () => (
  <svg
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8 5.59686C13.8 8.24633 11.6512 10.3937 9 10.3937C6.3488 10.3937 4.2 8.24633 4.2 5.59686C4.2 2.94739 6.3488 0.799988 9 0.799988C11.6512 0.799988 13.8 2.94739 13.8 5.59686Z"
      stroke="#424242"
      strokeLinecap="square"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 23.1854H1C1 22.0493 1 20.9685 1 19.9898C1 17.3388 3.14903 15.1906 5.8 15.1906H12.2C14.851 15.1906 17 17.3388 17 19.9898C17 20.9685 17 22.0493 17 23.1854Z"
      stroke="#424242"
      strokeLinecap="square"
    />
  </svg>
);

const SelectAcount = () => {
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch({ type: types.LOGOUT_START });
  };

  return (
    <Dropdown title={<Title />} position="left" leave>
      <ul className="dash-nav__list">
        <li>
          <button type="button" onClick={handleLogout} className="drop-option">
            <span className="dash-nav__ico">
              <div className="admin__btn">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M13.5 7.5L10.5 10.75M13.5 7.5L10.5 4.5M13.5 7.5L4 7.5M8 13.5H1.5L1.5 1.5L8 1.5" />
                </svg>
              </div>
            </span>

            <span className="drop-title drop-title-name">Logout</span>
          </button>
        </li>
      </ul>
    </Dropdown>
  );
};

export default SelectAcount;
